import fetchGql from '~/utils/fetchGql'

const query = gql`
  query NavigationfooterItems($startsWith: String) {
    NavigationfooterItems(starts_with: $startsWith, per_page: 1, resolve_links: "url") {
      items {
        content {
          awardImages {
            filename
            alt
          }
          awardText
          cookiePolicy {
            linktype
            story {
              fullSlug
            }
            fieldtype
            url
          }
          privacyPolicy {
            linktype
            story {
              fullSlug
            }
            url
          }
          leadershipPrivacyPolicy {
            linktype
            story {
              fullSlug
            }
            url
          }
        }
      }
    }
  }
`

const parseData = (data: any) => {
  return data[0].content
}

export const useFetchFooter = () => {
  const fetchFooter = (language: string) => {
    const variables = {
      startsWith: (language === 'en' ? '' : `${language}/`) + 'careers/data/navigation'
    }

    return fetchGql(query, variables).then((response: any) => {
      return parseData(response.NavigationfooterItems.items)
    })
  }

  return { fetchFooter }
}
